import React from 'react';
import Badge from '@material-ui/core/Badge';
import { FPIconButton } from 'UI/components/atoms';
import ConditionalActionWrapper from 'UI/components/atoms/ConditionalWrapper';
import { topBarIconSize } from 'UI/constants/dimensions';

import { useStyles } from '../../styles';

export const IconList = ({ icons }) => {
  const classes = useStyles({ isSmallViewPort: false });
  return icons.map(icon => (
    <ConditionalActionWrapper
      condition={!!icon.hasBadge}
      key={icon.key}
      wrapper={c => (
        <Badge
          classes={{ dot: icon.badgeClasses }}
          invisible={icon.isInvisibleBadge}
          variant="dot"
          color="primary"
          overlap="circular"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {c}
        </Badge>
      )}
    >
      <FPIconButton
        component="a"
        href={icon.href}
        target="_blank"
        rel="noopener noreferrer"
        icon={icon.icon}
        iconProps={{ size: topBarIconSize }}
        className={classes.gpacUIcon}
        onClick={icon.onClick}
        tooltipProps={{ title: icon.tooltipTitle }}
      />
    </ConditionalActionWrapper>
  ));
};
